import React, { useContext } from "react";

import "./About.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { aboutData } from "../../data/aboutData";

function About() {
  const { theme } = useContext(ThemeContext);
  const descParts = aboutData.description.split("webneotech.com");

  return (
    <div
      className="about"
      id="about"
      style={{ backgroundColor: theme.secondary }}
    >
      <div className="line-styling">
        <div
          className="style-circle"
          style={{ backgroundColor: theme.primary }}
        ></div>
        <div
          className="style-circle"
          style={{ backgroundColor: theme.primary }}
        ></div>
        <div
          className="style-line"
          style={{ backgroundColor: theme.primary }}
        ></div>
      </div>
      <div className="about-body">
        <div className="about-description">
          <h2 style={{ color: theme.primary }}>{aboutData.title}</h2>
          <p
            className="about-description-text"
            style={{ color: theme.tertiary80 }}
          >
            {descParts.length === 2 ? (
              <>
                {descParts[0]}
                <a
                  href="https://webneotech.com"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: theme.primary }}
                >
                  webneotech.com
                </a>
                {descParts[1]}
              </>
            ) : (
              aboutData.description
            )}
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
